<template>
  <div class="all">
    <div class="header-top">
      <el-button type="primary" size="small" plain @click="getfreshen">
        刷新
      </el-button>
      <el-button v-if="deleFrame" :disabled="!fileID" type="primary" size="small" plain @click="deleteBtn">
        删除
      </el-button>
      <el-button v-if="renameFrame" :disabled="!fileID" type="primary" size="small" plain @click="renameBtn">
        重命名
      </el-button>
      <el-button v-if="uploadFrame" type="primary" size="small" plain @click.capture.stop="clickUploadBtnHandler">
        上传
      </el-button>
      <el-button v-if="downFrame" :disabled="!fileID" type="primary" size="small" plain @click="download">
        下载
      </el-button>
      <el-button v-if="editFrame" :disabled="!fileID" size="small" type="primary" plain @click="editframe">
        修改备注
      </el-button>
      <input v-show="false" ref="upload-input" multiple accept=".dwg,.dwf,.txt" type="file" @change="httpRequest" />
    </div>
    <div class="midd">
      <el-table ref="multipleTable" :data="tableData" border highlight-current-row height="100%" @row-click="handleDelete">
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column label="序号" type="index" width="60" />
        <el-table-column label="文件名称" prop="fileName" min-width="200px" />
        <el-table-column label="创建人" prop="operatorName" />
        <el-table-column label="上传时间" prop="uploadTime" min-width="120px" />
        <el-table-column label="最近更新" prop="updateTime" min-width="120px" />
        <el-table-column label="备注" prop="remark" min-width="120px" />
      </el-table>
    </div>
    <!--修改 -->
    <el-dialog v-dialogDrag :visible.sync="editPersonDialog" :before-close="getEditPersonClose"
      :close-on-click-modal="false" :close-on-press-escape="false" title="备注" width="600px">
      <el-form ref="frameForm" :model="frameForm" :rules="rules" size="small">
        <el-form-item label="请选择图框类型:" prop="type">
          <el-select v-model="frameForm.type" style="width: 100%" clearable>
            <el-option v-for="(item, value) in frameType" :key="value" :value="item.value" :label="item.label" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注:" prop="remark" style="line-height: 40px">
          <el-input v-model="frameForm.name" :autosize="{ minRows: 2, maxRows: 6 }" type="textarea" maxlength="200" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="getEditPersonClose">取 消</el-button>
        <el-button type="primary" size="small" @click="editframeBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import provide from "@/CommonDP/service/sysFile-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import { mapState } from "vuex";
export default {
  name: "ProvideInformationFrame",
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      tableData: [],
      currentRow: {},
      editPersonDialog: false,
      frameForm: { type: "", name: "" },
      fileID: undefined,
      frameType: [
        {
          value: "通用",
          label: "通用"
        },
        {
          value: "其他",
          label: "其他"
        }
      ],
      upload: false,
      status: 0,
      list: [],
      rules: {
        type: [{ required: true, message: "类型必选", trigger: "change" }]
      },
      refreshFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_REFRESH),
      deleFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_DALE),
      renameFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_RENAME),
      uploadFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_UPLOAD),
      downFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_DOWN),
      editFrame: checkPermission(this.$allPerms.PROVIDEINFORMATIONFRAME_EDIT)
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },

  mounted() {
    this.getList();
  },
  methods: {
    clickUploadBtnHandler(e) {
      const a = disablePrompt();
      if (a) {
        const input = this.$refs["upload-input"];
        input.value = "";
        input.click();
      }
    },
    // 上传
    async httpRequest({ target }) {
      console.log(target.files);
      if (target && target.files) {
        if (target.files.length === 3) {
          const data = new FormData();
          const types = ["txt", "dwg", "dwf"];
          for (const item of target.files) {
            for (const type of types) {
              if (new RegExp("." + type + "$").test(item.name)) {
                data.append(type, item);
                break;
              }
            }
          }
          data.append("remark", "");
          data.append("standardType", 4);
          data.append("enterpriseId", this.enterpriseId);
          const res = await provide.raiseCapitalUpload(data);
          if (res.result === "0") this.$message.success("上传成功");
          this.getList();
        } else {
          this.$message({
            message: "请上传含dwg,dwf,txt的三个同名文件",
            type: "warning"
          });
        }
      }
    },
    // 列表
    getList() {
      this.tableData = [];
      provide.raiseCapitalQueryList(4, this.enterpriseId).then(({ data }) => {
        this.tableData = data || [];
      });
    },
    // 选中的节点
    handleDelete(val) {
      this.currentRow = val;
      this.fileID = val.fileID;
    },
    // 刷新
    getfreshen() {
      this.currentRow = {};
      this.fileID = undefined;
      this.getList();
    },
    // 重命名
    renameBtn() {
      const a = disablePrompt();
      if (a) {
        const row = this.currentRow;
        const { $prompt, enterpriseId } = this;
        const reg = /\.[\w\d]+?$/;
        const reNameStr = row.fileName.replace(reg, "");
        const extName = row.fileName.slice(reNameStr.length);
        $prompt("请输入文件名称", "编辑文件名称", {
          inputPlaceholder: "输入文件名称",
          inputValue: reNameStr,
          inputErrorMessage: "请输入除空格外的100文字以内的名称",
          inputPattern: /^\S{1,100}$/,
          beforeClose: (action, { inputValue }, done) => {
            if (action === "confirm") {
              const folderForm = {
                fileName: inputValue + extName,
                fileID: row.fileID,
                enterpriseId
              };
              provide.raiseCapitalUpdate(folderForm).then((data) => {
                if (data.result === "0") {
                  this.$message({
                    showClose: true,
                    type: "success",
                    message: "修改成功"
                  });
                }
                this.currentRow = {};
                this.fileID = undefined;
                this.getList();
                done();
              });
            } else {
              done();
            }
          }
        });
      }
    },
    // 删除
    async deleteBtn() {
      const a = disablePrompt();
      if (a) {
        await this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        const params = {
          fileID: this.fileID,
          isdelete: 1,
          enterpriseId: this.enterpriseId
        };
        const res = await provide.raiseCapitalUpdate(params);
        if (res.result === "0") {
          this.$message({ message: "删除成功", type: "success" });
        }
        this.currentRow = {};
        this.fileID = undefined;
        this.getList();
      }
    },
    // 下载
    async download() {
      const a = disablePrompt();
      if (a) {
        const batchArr = this.currentRow;
        const fileID = this.fileID;
        provide.raiseCapitalDownload(fileID).then((response) => {
          const fileName = batchArr.fileName.replace(/dwg$/i, "zip");
          if (response.type === "application/json") {
            const fileReader = new FileReader();
            fileReader.onloadend = () => {
              const jsonData = JSON.parse(fileReader.result);
              // 后台信息
              this.$message({ message: jsonData.message, type: "error" });
            };
            fileReader.readAsText(response); // 或者读取response.data
          } else {
            const link = document.createElement("a");
            const blob = new Blob([response], {
              type: "application/octet-stream"
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
      }
    },
    // 修改
    async editframe() {
      const a = disablePrompt();
      if (a) {
        this.editPersonDialog = true;
        const { data } = await provide.raiseCapitalQueryInfo(this.fileID);
        if (data.remark && data.remark.indexOf(":") !== -1) {
          this.frameForm.type = data.remark.slice(0, 2);
          this.frameForm.name = data.remark.slice(3);
        } else {
          this.frameForm.type = "";
          this.frameForm.name = "";
        }
      }
    },
    // 修改保存
    async editframeBtn() {
      await this.$refs.frameForm.validate();
      const {
        frameForm: { type, name },
        fileID,
        enterpriseId
      } = this;
      const params = {
        remark: name ? type + ":" + name : type,
        fileID,
        enterpriseId
      };
      const res = await provide.raiseCapitalUpdate(params);
      if (res.result === "0") {
        this.$message({
          showClose: true,
          type: "success",
          message: "修改成功"
        });
      }
      this.currentRow = {};
      this.fileID = undefined;
      this.getEditPersonClose();
    },
    getEditPersonClose() {
      this.$refs.frameForm.resetFields();
      this.editPersonDialog = false;
      this.currentRow = {};
      this.fileID = undefined;
      this.getList();
    }
  }
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  position: relative;
  background-color: #fff;
}
.header-top {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  height: 50px;
  padding: 10px;
  .header_b {
    margin-top: 10px;
    margin-left: 20px;
  }
}
.midd {
  position: absolute;
  top: 60px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 4px 10px;
}
</style>
